import React from "react"
import PropTypes from "prop-types"
import Icon from "app/static/frontend/components/Icon"
import Tooltip from "app/static/frontend/components/Tooltip"
import sortTypes, { reverseSortDirection } from "app/static/frontend/sheets/sort-types"
import { sortWarningText } from "app/static/frontend/sheets/components/helpTexts"
const ColumnSortingIndicator = ({
    canSort,
    columnIndex,
    columnId,
    sorting,
    id,
    sortByColumnAtIndex,
    sortType,
    clearSort,
    defaultSortingType,
    canSetDefaultSort,
    isDefaultSorting,
    toggleDefaultSortOnColumn,
}) =>
    sorting ? (
        <div>
            {canSetDefaultSort ? (
                <Tooltip
                    label={
                        isDefaultSorting && defaultSortingType === sortType
                            ? "Click to unpin this sort (remove default sorting)"
                            : "Click to pin this sort (sheet will be sorted like this by default)"
                    }
                >
                    <div>
                        <Icon
                            className={
                                isDefaultSorting && defaultSortingType === sortType
                                    ? "selected default-sort"
                                    : "default-sort"
                            }
                            name="thumb-tack"
                            onClick={() => {
                                toggleDefaultSortOnColumn(
                                    id,
                                    columnId,
                                    isDefaultSorting && defaultSortingType === sortType ? 0 : sortType,
                                )
                            }}
                        />
                    </div>
                </Tooltip>
            ) : (
                ""
            )}
            <Tooltip label="Click to Reverse Sort">
                <div>
                    <Icon
                        dataCy="column-reverse-sort"
                        name={sortType === sortTypes.ASC ? "sort-amount-asc" : "sort-amount-desc"}
                        onClick={() => sortByColumnAtIndex(id, columnIndex, reverseSortDirection(sortType))}
                    />
                </div>
            </Tooltip>
            <Tooltip label="Click to Clear Sorting">
                <div>
                    <Icon dataCy="clear-sorting" name="fa-times-circle-o" onClick={() => clearSort(id)} />
                </div>
            </Tooltip>
        </div>
    ) : (
        <Tooltip label={canSort ? "Sort" : sortWarningText}>
            <div>
                <Icon
                    dataCy="column-sort"
                    disabled={canSort}
                    name="unsorted"
                    style={!canSort ? { color: "red" } : {}}
                    onClick={() => (canSort ? sortByColumnAtIndex(id, columnIndex, sortTypes.DESC) : null)}
                />
            </div>
        </Tooltip>
    )

ColumnSortingIndicator.propTypes = {
    columnIndex: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    clearSort: PropTypes.func.isRequired,
}

export default ColumnSortingIndicator
